import { appConfig } from 'config/environment/appConfig'

import { AuthRoutesEnum } from 'shared/constants/routes'

import { ErrorResponseData } from '../types/types'
import { HttpResponseError } from './Errors/HttpResponseError'
import { getLocalStorageData, setLocalStorageData, STORAGE_KEY } from './localStorage.service'

export async function assertHttpResponse(response: Response, fullUrlPrev: string, requestPrev: RequestInit) {
  if (isSuccess(response)) {
    return
  }

  const { error }: ErrorResponseData = await response.json()

  const { status } = response
  const serverErrorMsg = 'Ошибка на сервере. Обратитесь к администратору'
  let msg: string = ''

  switch (status) {
    case 400:
      msg = error?.message ?? 'Ошибка запроса.'
      break
    case 401: {
      const headers = {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'X-Token': getLocalStorageData(STORAGE_KEY.ACCESS_TOKEN),
      }

      const request: RequestInit = {
        method: 'POST',
        headers,
      }

      const body = {
        backoffice: false,
        token: getLocalStorageData(STORAGE_KEY.REFRESH_TOKEN),
      }

      request.body = JSON.stringify(body)

      const url = 'api/v2/token/refresh'
      const fullUrl = `${appConfig.API_URL}${url}`
      const resp = await fetch(fullUrl, request)
      const data = await resp.json()

      if (!isSuccess(resp)) {
        handle401Error()
      } else {
        setLocalStorageData(STORAGE_KEY.ACCESS_TOKEN, data.access.token)
        setLocalStorageData(STORAGE_KEY.REFRESH_TOKEN, data.refresh.token)

        // @ts-expect-error: @
        requestPrev.headers['X-Token'] = data.access.token

        return await fetch(fullUrlPrev, requestPrev)
      }
      break
    }
    case 500:
      msg = (error?.data?.[0]?.value || error?.message) ?? serverErrorMsg
      break
    case 502:
      break
    default:
      msg = (error?.data?.[0]?.value || error?.message) ?? serverErrorMsg
      break
  }

  throw new HttpResponseError(response, msg, error)
}

function isSuccess(response: Response): boolean {
  return response.status >= 200 && response.status < 300
}

function handle401Error() {
  localStorage.clear()
  window.location.href = AuthRoutesEnum.login
}
